import React, { useEffect, useState } from "react";
import { getDisplayName } from "../utils/displayName";
import { userById } from "../actions/userById";
import { useNavigate } from "react-router-dom";
import { cloudinaryUrl } from "../constants/CloudinaryConstants";

const Poster = ({ poster }) => {
  const [posterr, setPoster] = useState(null);
  useEffect(() => {
    userById(poster?.user_id, { setPoster });
  }, [poster]);
  const nav = useNavigate();

  const listedDate = poster?.listing_start_date || poster?.listed_date;
  let daysOnMarket = null;
  if (listedDate) {
    try {
      daysOnMarket = Math.max(
        1,
        Math.floor((new Date() - new Date(listedDate)) / (1000 * 60 * 60 * 24)),
      );
    } catch (e) {
      daysOnMarket = null;
    }
  }

  return (
    <>
      {poster && poster["listed_date"] && (
        <>
          <div className="flex items-center justify-between mt-4">
            <h1 className="font-bold">
              Posted on{" "}
              {new Date(poster["listed_date"]).toLocaleDateString("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
              })}
            </h1>
            {daysOnMarket !== null && (
              <div className="text-sm text-gray-600">
                <span className="font-semibold text-gray-800">
                  Days On Market:{" "}
                </span>
                <span className="font-medium">{daysOnMarket}</span>
              </div>
            )}
          </div>
          <div
            className="border-2 rounded-10 mt-2 py-2 px-8 flex items-center justify-between w-max gap-8 hover:scale-105 hover:cursor-pointer transition-all"
            onClick={() => nav(`/user/${poster?.user_id}`)}
          >
            <img
              className="h-[60px] w-[60px] object-cover rounded-full"
              src={
                posterr?.picture_url
                  ? cloudinaryUrl(posterr?.picture_url)
                  : "/error.png"
              }
              alt="poster"
            />
            <div className="text-center">
              <h1 className="text-19">
                {Number(posterr?.user_id) === 16 ||
                posterr?.email === "tonythebroker956@gmail.com"
                  ? "Broker / Owner of Glass Realty"
                  : getDisplayName(posterr)}
              </h1>
              <p className="text-blue-500">{posterr?.brokerage_name}</p>
              <p className="text-sm font-medium text-slate-700">
                {posterr?.class_type}
              </p>
              {posterr?.email_address && (
                <p className="text-xs text-slate-600 mt-1">
                  <a
                    href={`mailto:${posterr.email_address}`}
                    className="hover:underline"
                  >
                    {posterr.email_address}
                  </a>
                </p>
              )}
              {posterr?.phone_number && (
                <p className="text-xs text-slate-600">
                  <a
                    href={`tel:${posterr.phone_number}`}
                    className="hover:underline"
                  >
                    {posterr.phone_number}
                  </a>
                </p>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Poster;
